import { isNullOrUndefined } from 'util';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { QAResponse } from '../../shared/qaTicket';

@Component({
  selector: "app-mismatchquestionsinsubmit",
  templateUrl: "./mismatchquestionsinsubmit.component.html",
  styleUrls: ["./mismatchquestionsinsubmit.component.scss"]
})

export class MismatchquestionsinsubmitComponent implements OnInit {
  
  constructor(public dialogRef: MatDialogRef<MismatchquestionsinsubmitComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {

  }

  OnCloseConfirm() {
    this.dialogRef.close('ok');
  }

  OnCloseCancel() {
    this.dialogRef.close('cancel');
  }

}
